<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    />
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="table.title"
    />
  </div>
</template>

<script>
import * as dept from "@/api/dept/dept.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      formData: {},
      formDesc: {
        parent_id: {
          label: "父级菜单",
          type: "tree-select",
          options: dept.getDeptTree.r()
          // options: [{ id: 1 ,label:'asd' }]
        },
        dept_name: {
          label: "部门名称",
          type: "input"
        },
        leader: {
          label: "负责人",
          type: "input"
        },
        phone: {
          label: "负责人电话",
          type: "input"
        },
        email: {
          label: "负责人邮箱",
          type: "input"
        },
        status: {
          label: "状态",
          type: "radio",
          layout: 12,
          default: 0,
          options: [
            {
              text: "正常",
              value: 0
            },
            {
              text: "停用",
              value: 1
            }
          ]
        },
        order_num: {
          layout: 12,
          label: "排序",
          type: "input"
        }
      },
      rules: {},
      dialogFormVisible: false,
      deptTree: [],
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "部门",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        rowKey: "dept_id",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "parent_id",
            label: "父级菜单",
            type: "tree-select",
            hide: false
          },
          {
            prop: "dept_name",
            label: "部门名称",
            type: "input",
            hide: true
          },
          {
            prop: "leader",
            label: "负责人",
            type: "input",
            hide: true
          },
          {
            prop: "phone",
            label: "负责人电话",
            type: "input",
            hide: false
          },
          {
            prop: "email",
            label: "负责人邮箱",
            type: "input",
            hide: false
          },
          {
            prop: "status",
            label: "状态",
            type: "radio",
            show: "tag",
            layout: 12,
            default: 0,
            options: [
              {
                text: "正常",
                value: 0
              },
              {
                text: "停用",
                value: 1
              }
            ],
            tagtype: [
              {
                text: "正常",
                type: "success",
                value: 0
              },
              {
                text: "停用",
                type: "danger",
                value: 1
              }
            ],
            hide: true
          },
          {
            prop: "create_by",
            label: "创建人",
            type: "input",
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false,
            hide: true
          },
          {
            layout: 12,
            prop: "order_num",
            label: "排序",
            type: "input",
            hide: true
          },

          {
            prop: "create_time",
            label: "创建时间",
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false,
            hide: true
          }
          //   {
          //     prop: "update_time",
          //     label: "更新时间",
          //     // 该字段是否可以在创建时编辑 默认:true;
          //     addDisplay: false,
          //     // 该字段是否可以修改默认true
          //     editDisplay: false,
          //     hide: true
          //   }
        ],
        btnNavLeft: [
          {
            text: "添加",
            size: "mini",
            type: "success",
            click: () => {
              this.submitType = 1;
              this.dialogFormVisible = true;
            }
          }
        ],
        btnList: [
          {
            name: "编辑",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.formData = row;
              this.submitType = 2;
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      tableData: [],
      submitType: 1
    };
  },
  created() {
    this.getlist();
    this.getDeptTree();
  },
  methods: {
    handleSubmit(form) {
      if (this.submitType === 1) {
        dept.addDept.r(form).then(res => {
          this.$message.success("部门《" + res.dept_name + "》创建成功");
          this.getlist();
        });
      } else if (this.submitType === 2) {
        dept.editDept.r(form).then(res => {
          if (res.status) this.$message.success("修改成功");
          else this.$message.success("修改失败");
          this.getlist();
        });
      }
    },
    handleSuccess() {},
    //   dept.getDeptTree.r()
    getDeptTree() {
      dept.getDeptTree.r().then(res => {
        this.deptTree = res;
        this.table.column[0]["options"] = res;
      });
    },
    // 添加提交
    addSubmit(form) {
      form["menu_ids"] = [];
      dept.addDept.r(form).then(res => {
        this.$message.success("部门《" + res.dept_name + "》创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      dept.editDept.r(form).then(res => {
        if (res.status) this.$message.success("修改成功");
        else this.$message.success("修改失败");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          dept.deleteDept.r({ dept_id: form.dept_id }).then(res => {
            console.log("成功");
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      dept.getDeptList.r(param).then(res => {
        that.tableData = res.depts_tree;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
